import React, { createContext, useCallback, useState } from 'react'

interface LoadingContextProps {
  loading: boolean;
  loadingMessage: string;
  changeLoadingMessage(value: string): void;
  changeLoadingState(value: boolean): void
};

const LoadingContext = createContext<LoadingContextProps>({loading: false, loadingMessage: '', changeLoadingMessage: () => {},  changeLoadingState: () => {}});

export const LoadingProvider: React.FC = ({children}) => {
  const [loading, setLoading] = useState(false);
  const changeLoadingState = useCallback((val: boolean) => setLoading(val),[]);
  const [loadingMessage, setLoadingMessage] = useState('');
  const changeLoadingMessage = useCallback((val: string) => setLoadingMessage(val),[]);
  
  return (
    <LoadingContext.Provider value={{loading,loadingMessage, changeLoadingMessage, changeLoadingState}}>
      {children}
    </LoadingContext.Provider>
  );
}

export default LoadingContext;